import React from "react";
import verifySeats from "../plugins/realTimeMapping";
import {final,pass3} from "../plugins/syncDatas";

function isValid(element){
    element.classList.add("is-valid")
    element.classList.remove("is-invalid")
}

function isInvalid(element){
    element.classList.remove("is-valid")
    element.classList.add("is-invalid")
}

function checkValidForm(element){
    var flag = true;
    element.querySelectorAll(".input-group").forEach(element=>{
        if (element.classList.contains("is-invalid") || element.querySelector("input").value.length == 0){
            flag=false;
        }
    })

    if (flag){
        element.querySelector(".button-group button").removeAttribute("disabled")
        element.querySelector(".button-group button").classList.remove("disabled")
    }else{
        element.querySelector(".button-group button").setAttribute("disabled","disabled")
        element.querySelector(".button-group button").classList.add("disabled")
    }
}
export default class MapForm extends React.Component{

    checkValue(evt){
       var valor = evt.target.value;
       var button =document.querySelector(".step-1 button");

       if (valor > 0){
           button.classList.remove("disabled")
           button.removeAttribute("disabled")
           isValid(evt.target.parentElement)
       }else{
           button.classList.add("disabled")
           button.setAttribute("disabled","disabled")
           isInvalid(evt.target.parentElement)
       }

       checkValidForm(evt.target.parentElement.parentElement)
    }

    validateName(evt){
        var name_regex = new RegExp("^[A-Za-zÁÉÍÓÚáéíóúñÑ]{3,}( [A-Za-zÁÉÍÓÚáéíóúñÑ]{2,})*$");
        if (name_regex.test(evt.target.value)){
            isValid(evt.target.parentElement)
        }else{
            isInvalid(evt.target.parentElement)
        }

        checkValidForm(evt.target.parentElement.parentElement)
    }

    validateLastName(evt){
        var name_regex = new RegExp("^[A-Za-zÁÉÍÓÚáéíóúÑñ]{2,}( [A-Za-zÁÉÍÓÚáéíóúÑñ]{2,})*$");
        if (name_regex.test(evt.target.value)){
            isValid(evt.target.parentElement)
        }else{
            isInvalid(evt.target.parentElement)
        }
        checkValidForm(evt.target.parentElement.parentElement)
    }

    validateEmail(evt){
        var name_regex = new RegExp("^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$");
        if (name_regex.test(evt.target.value)){
            isValid(evt.target.parentElement)
        }else{
            isInvalid(evt.target.parentElement)
        }
        checkValidForm(evt.target.parentElement.parentElement)
    }

    validatePhone(evt){
        var name_regex = new RegExp("^[0-9]{10}$");
        if (name_regex.test(evt.target.value)){
            isValid(evt.target.parentElement)
        }else{
            isInvalid(evt.target.parentElement)
        }
        checkValidForm(evt.target.parentElement.parentElement)
    }

    validateCard(evt){
        var name_regex = new RegExp("^[0-9]{15,16}$");
        if (name_regex.test(evt.target.value)){
            isValid(evt.target.parentElement)
        }else{
            isInvalid(evt.target.parentElement)
        }
        checkValidForm(evt.target.parentElement.parentElement)
    }

    validateExpiration(evt){
        var name_regex = new RegExp("^[0-9]{2}$");
        if (name_regex.test(evt.target.value)){
            isValid(evt.target.parentElement)
        }else{
            isInvalid(evt.target.parentElement)
        }
        checkValidForm(evt.target.parentElement.parentElement)
    }

    validateCVV(evt){
        var name_regex = new RegExp("^[0-9]{3,4}$");
        if (name_regex.test(evt.target.value)){
            isValid(evt.target.parentElement)
        }else{
            isInvalid(evt.target.parentElement)
        }
        checkValidForm(evt.target.parentElement.parentElement)
    }

    validatePwd(evt){
        if (evt.target.value.length > 0){
            isValid(evt.target.parentElement)
        }        else {
            isInvalid(evt.target.parentElement)
        }

        checkValidForm(evt.target.parentElement.parentElement)
    }




    render() {
        return (
            <div className="map-form">
                <div className="form-group step-1">
                    <div className="title titulo-asientos">Asientos</div>
                    <div className="input-group">
                        <label htmlFor="" className="label-asientos">Elige el número de lugares que deseas comprar: </label>
                        <input type="number" onKeyUp={this.checkValue} name="lugares" id="lugares" inputMode={"numeric"} disabled/>
                    </div>
                    <div className="input-group is-invalid pwd">
                        <label htmlFor="" className="contraseña">Ingresa la contraseña que se te ha proporcionado:</label>
                        <input type="password" id="pwd" onKeyUp={this.validatePwd}/>
                    </div>
                    <div className="button-group">
                        <button type="button" onClick={verifySeats} className={"disabled btn-1"}>Buscar lugares</button>
                    </div>
                </div>
                <div className="form-group hide step-2">
                    <div className="title personal-data">Datos Personales</div>
                    <div className="details">
                        <label htmlFor="" className="detalles">Detalles:</label><br/>
                        <div className="cart">
                            <div className="item">
                                <div className="name label-table">
                                    Mesa:
                                </div>
                                <div className="value table"></div>
                            </div>
                            <div className="item">
                                <div className="name label-seats">
                                    Asientos:
                                </div>
                                <div className="value seats"></div>
                            </div>
                            <div className="item">
                                <div className="name label-total">
                                    Total:
                                </div>
                                <div className="value total"></div>
                            </div>
                        </div>

                    </div>
                    <label htmlFor="" className="label-nombre">Nombre</label>
                    <div className="input-group">
                        <input type="text" onKeyUp={this.validateName} name="nombre" id="nombre"/>
                    </div>
                    <label htmlFor="" className="label-apellido-paterno">Apellido paterno</label>
                    <div className="input-group">
                        <input type="text" onKeyUp={this.validateLastName} name="ap_paterno" id="ap_paterno" className="label"/>
                    </div>
                    <label htmlFor="" className="label-apellido-materno">Apellido materno</label>
                    <div className="input-group">
                        <input type="text" name="ap_materno" id="ap_materno" />
                    </div>
                    <label htmlFor="" className="label-correo">Correo electrónico</label>
                    <div className="input-group" >
                        <input type="text" name="email" id="email" onKeyUp={this.validateEmail}/>
                    </div>
                    <label htmlFor="" className="label-telefono">Teléfono Celular</label>
                    <div className="input-group">
                        <input type="number" name="telefono" id="telefono" inputMode={"numeric"} onKeyUp={this.validatePhone}/>
                    </div>
                    <div className="button-group">
                        <button className="btn-2" onClick={pass3}>Continuar</button>
                    </div>
                </div>
                <div className="form-group hide step-3">
                    <div className="title banco">Datos Bancarios</div>
                    <div className="details">
                        <label htmlFor="">Detalles:</label><br/>
                        <div className="cart">
                            <div className="item">
                                <div className="name">
                                    Mesa:
                                </div>
                                <div className="value table"></div>
                            </div>
                            <div className="item">
                                <div className="name">
                                    Asientos:
                                </div>
                                <div className="value seats"></div>
                            </div>
                            <div className="item">
                                <div className="name">
                                    Total:
                                </div>
                                <div className="value total"></div>
                            </div>
                        </div>

                    </div>
                    <div className="input-group">
                        <input className="tarjeta" type="text" placeholder="Número de tarjeta" id="55" onKeyUp={this.validateCard}/>
                    </div>
                    <div className="input-group">
                        <input className="m-exp" type="text" placeholder="Mes expiración (MM)" id="56" onKeyUp={this.validateExpiration}/>
                    </div>
                    <div className="input-group">
                        <input className="a-exp" type="text" placeholder="Año de expiración (YY)" id="57" onKeyUp={this.validateExpiration}/>
                    </div>
                    <div className="input-group">
                        <input type="text" placeholder="CVV" id="103" onKeyUp={this.validateCVV}/>
                    </div>
                    <div className="input-group">
                        <input className="titular"  type="text" placeholder="Nombre del titular" id="58" onKeyUp={this.validateLastName}/>
                    </div>
                    <div className="button-group">
                        <button className="btn-f" onClick={final}>Pagar y Finalizar</button>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/MapForm.js